module.exports = __webpack_public_path__ + "static/media/ios-chrome-settings.37893d23.jpeg";